export default {
  isAuthenticated: state => !!state.token,
}
